import useBulkCampaignFromIdentifier from "./useBulkCampaignFromIdentifier";

export default useBulkCampaignFromIdentifier;
